export class Infrastructures {
    id: number;
    code: string;
    name: string;
    isChuyenBiet : boolean;
    isHoaNhap : boolean;
    displayOrder: number;
}